// extracted by mini-css-extract-plugin
export default {"link":"NB-z","disabled":"OB-z"};